import { useEffect, useState } from 'react';
import {
  isGritoWindow,
  isMesPatrioEnabled,
  MES_PATRIO_EVENT,
  shouldPlayIndependenciaCeremony
} from '../utils/mesPatrio';

export function useMesPatrio() {
  const [enabled, setEnabled] = useState(() => isMesPatrioEnabled());
  const [grito, setGrito] = useState(() => isGritoWindow());
  const [ceremony, setCeremony] = useState(() => shouldPlayIndependenciaCeremony());

  useEffect(() => {
    const sync = () => {
      setEnabled(isMesPatrioEnabled());
      setGrito(isGritoWindow());
      setCeremony(shouldPlayIndependenciaCeremony());
    };
    window.addEventListener(MES_PATRIO_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(MES_PATRIO_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return { enabled, grito, ceremony };
}
